import DateTimeMixin from './DateTimeMixin';
import NumbersMixin from './NumbersMixin';

export default {
    mixins: [DateTimeMixin, NumbersMixin],
    methods:
    {
        toDisplayString: function(value, displayFormat, obj) {
            if (displayFormat)
            {
                if (displayFormat.type == 'datetime')
                {
                    var mode = 'includetime';
                    var outputAsUTC = false;
                    if (displayFormat.options)
                    {
                        if (displayFormat.options.mode) mode = displayFormat.options.mode;
                        if (displayFormat.options.outputAsUTC || (displayFormat.options.outputAsUTC === true)) outputAsUTC = displayFormat.options.outputAsUTC;
                        if (displayFormat.options.tzMode)
                        {
                            if (displayFormat.options.tzMode == "utc") outputAsUTC = false;
                            else if (displayFormat.options.tzMode == "notz") outputAsUTC = true;
                        }
                    }
                    var dateTimeUTCString = this.formatDateTime(value, 'YYYY-MM-DDTHH:mm:ss', true, true);
                    if ((mode == 'excludetime') ||
                        (((mode == 'checktime') || (mode == 'checktimeincludeseconds')) && (dateTimeUTCString.indexOf('00:00:01') > 0))) { //if the required date/time is 1 second past midnight UTC then that actually means there is no specific time, just the date
                        return this.formatDateTime(dateTimeUTCString, 'DD/MM/YYYY', true, outputAsUTC);
                    }
                    if (mode == 'onlytimewithseconds') {
                        return this.formatDateTime(dateTimeUTCString, 'hh:mm:ssA', true, outputAsUTC);
                    }
                    if (mode == 'onlytime') {
                        return this.formatDateTime(dateTimeUTCString, 'hh:mmA', true, outputAsUTC);
                    }
                    if ((mode == 'includetimewithseconds') || (mode == 'checktimeincludeseconds')) {
                        return this.formatDateTime(dateTimeUTCString, 'DD/MM/YYYY hh:mm:ssA', true, outputAsUTC);
                    }
                    return this.formatDateTime(dateTimeUTCString, 'DD/MM/YYYY hh:mmA', true, outputAsUTC);
                }
                else if (displayFormat.type == 'currency')
                {
                    var currencyCode = null;
                    var currencyCodeProperty = null;
                    if (displayFormat.options)
                    {
                        if (displayFormat.options.currencyCode) currencyCode = displayFormat.options.currencyCode;
                        if (displayFormat.options.currencyCodeProperty) currencyCodeProperty = displayFormat.options.currencyCodeProperty;
                    }
                    if (obj && currencyCodeProperty) {
                        var ccValue = obj;
                        currencyCodeProperty.split('.').forEach(property => {
                            if (ccValue) {
                                ccValue = ccValue[property];
                            }
                        });
                        if (ccValue) currencyCode = ccValue;
                    }
                    return this.formatAsCurrency(value, currencyCode);
                }
                else if (displayFormat.type == 'percentage')
                {
                    var numberIsPercentage = false;
                    if (displayFormat.options)
                    {
                        if (displayFormat.options.numberIsPercentage || (displayFormat.options.numberIsPercentage === true)) numberIsPercentage = displayFormat.options.numberIsPercentage;
                    }
                    return this.formatAsPercentage(value, numberIsPercentage);
                }
            }
            return value;
        }
    }
}